import React, { useCallback, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Toolbar, Box } from '@mui/material'

import logoBlue from 'assets/markaazLogoBlue.svg'
import logoWhite from 'assets/markaazLogoWhite.svg'
import routes from 'routes'
import { styled } from '@mui/material/styles'

const AppBarStyle = styled(Box)(({ theme }) => ({
  background: 'transparent',
  boxShadow: 'none',
  width: '100%',
  zIndex: '12345677',
  // [theme.breakpoints.down(813)]: {
  //   background: 'rgb(248, 250, 251)',
  // },
}))

const sx = {
  text: {
    marginRight: theme => theme.spacing(2),
    fontSize: '14px',
    fontWeight: 'lighter',
    [theme => theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  toolbar: {
    minHeight: '76.9px',
    background: '#ffffff',
    justifyContent: 'space-between',
  },
  toolbarLoggedOut: {
    minHeight: '76.9px',
    background: 'transparent',
    justifyContent: 'space-between',
  },
  logo: theme => ({
    width: '108px',
    height: '27.69px',
    [theme.breakpoints.down(813)]: {
      width: '76.58px',
      height: '19.79px',
    },
  }),
}

const LoggedOutControls = ({ publicPage, controls }) => {
  const location = useLocation()
  const [bg, setBg] = useState('transparent')
  const setBG = useCallback(() => {
    if (publicPage) setBg('rgb(248, 250, 251)')
    else window.pageYOffset > 0 ? setBg('rgb(248, 250, 251)') : setBg('transparent')
  }, [publicPage])

  const toMarkaaz = useCallback(() => {
    window.location.replace(`${'https://markaaz.com'}`)
  }, [])

  useEffect(() => {
    // TODO: rewrite/improve maybe

    if (publicPage) setBg('rgb(248, 250, 251)')

    window.addEventListener('scroll', setBG, { passive: true })
    return () => {
      window.removeEventListener('scroll', setBG)
    }
  }, [location, setBG, publicPage])

  return (
    // <AppBar position="fixed">
    <AppBarStyle position="fixed">
      <Toolbar sx={sx.toolbarLoggedOut} style={{ backgroundColor: bg }}>
        <Link to={routes.home} onClick={toMarkaaz}>
          {bg === 'transparent' && <Box component="img" src={logoWhite} sx={sx.logo} alt="Markaaz" />}
          {!bg.includes('transparent') && <Box component="img" src={logoBlue} sx={sx.logo} alt="Markaaz" />}
        </Link>
      </Toolbar>
    </AppBarStyle>
    // </AppBar>
  )
}

export default LoggedOutControls
